enum LensBuilderType {
  FRAME = 0,
  VISION_NEED = 1,
  LENS_PACKAGE = 2,
  PRESCRIPTION = 3,
  PRESCRIPTION_ONLY = 4,
}

export default LensBuilderType;
